<template>
  <v-card class="main-card">
    <div class="d-flex flex-nowrap justify-space-between">
      <v-container>
        <v-row>
          <v-col cols=6 class="pa-0 ml-2">
            <v-card-text class="pa-0">
              <p class="subtitle-2 text-left">
                <v-chip color="#15336d" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-radioactive</v-icon>
                  </v-avatar>
                  <b style="color:white;"
                  >{{InputData.type==3 ? 'пучок КИСИ' : 'пучок ИР-8'}}</b>
                </v-chip>
              </p>
            </v-card-text>
          </v-col>
        </v-row>
        
        <v-spacer></v-spacer>
        <v-row class="ml-2">
          <set-date-intervals
            @updateParent="update_parent($event)" 
            :proposal_id="0"
            :station_id="0"
            :can_edit="true"
            :input_dates ="dates"
            :interval_multiple="false"
            :availiable_limit="740"
            :calendar_id="InputData.id"
            :add_new="add_new"
            :small_view="false"
            :calendar_type="InputData.type"
            />
        </v-row>
        <v-spacer></v-spacer>
        
        <v-row v-if="!add_new">
          <div class="bs-actions ml-5">
            <v-btn color="red darken-1" text @click="closeRecord()" :loading="loaded">удалить интервал</v-btn>
          </div>
        </v-row>

      </v-container>
    </div>


  </v-card>

</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import setDateIntervals from "../../Proposals/setDateIntervals.vue";

export default {
  name: "calendarCard",
  props: {
    InputData: Object,
    add_new: Boolean,
  },
  components: {
      setDateIntervals
  },
  
  data() {
    return {
      dates: [],
      loaded: false,
    };
  },
  methods: {
    ...mapActions([
      'UPDATE_CALENDAR_REC',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    prepare_data(){
        this.dates = [
          this.formate_date(this.InputData.source.start_date),
          this.formate_date(this.InputData.source.finish_date),
        ]
    },

    formate_date(str){
      var date_obj = new Date(str)
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate() 
      var m = date_obj.getMinutes()
      var h = date_obj.getHours()
      if (h<10) h = '0'+h
      if (m<10) m = '0'+m
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date_obj.getFullYear() + '-' + month + '-' + date + ' ' + h + ':' + m
    },

    closeRecord(args){
        this.loaded = true
        this.UPDATE_OVERLAY(true)
        this.UPDATE_CALENDAR_REC({
          id: this.InputData.id, 
          close_record: true
        })
        .then(res => {
          this.UPDATE_OVERLAY(false)
          this.loaded = false
          this.$emit('updateParent')
        })
        .catch(() => {
          this.UPDATE_OVERLAY(false)
            this.loaded = false
        })

    },

    update_parent(item) {
      this.$emit('updateParent')
    },

  },

  watch: {
    InputData:{
      handler: function (val, oldVal) { 
        this.prepare_data()
      },
      deep: true
    },
  },
  
  beforeMount(){
    this.prepare_data()
  },
};
</script>

<style scoped>
  .bs-actions {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
  }

.main-card {
  background-color: #f4f5f7 !important;
  border-radius: 2px;
}
.main-card * {
  color: #15336d;
}
</style>